import React from "react";
import PropTypes from "prop-types";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";

const { SITE_NAME } = process.env;

const CityBreadcrumbs = ({ city, state }) => (
	<Box pb={6} pt={6}>
		<Container maxWidth="md">
			<Breadcrumbs
				separator="//"
				aria-label="breadcrumb"
				color="textSecondary"
				style={{ fontSize: 14, lineHeight: "16px" }}
			>
				<Link color="inherit" href="/">
					{SITE_NAME.ucFirst()}
				</Link>
				<Link color="inherit" href={`${state.url}/`}>
					{city.state.toUpperCase()}
				</Link>
				<Link color="inherit" href={`${city.url}/`}>
					{city.name.ucFirst()}
				</Link>
			</Breadcrumbs>
		</Container>
	</Box>
);

CityBreadcrumbs.propTypes = {
	city: PropTypes.shape({
		state: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
	}).isRequired,
	state: PropTypes.shape({
		url: PropTypes.string.isRequired,
	}).isRequired,
};

export default CityBreadcrumbs;
